
import React, { Component } from 'react';
import './archive.scss'
import { Modal, ModalBody } from "reactstrap";
import { ImageConstants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'

class ArchiveComponent extends Component {

    onClickArchive = () => {
        this.props.delegate.onClickArchive && this.props.delegate.onClickArchive(this.props.selectedItem)
    }

    onCLickCancel = () => {
        this.props.onClose && this.props.onClose()
    }

    render() {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.props.onClose} size={this.props.size || 'md'}>

                <ModalBody >
                    <div className="archive-modal">
                        <div className="row">
                            <div className="col">
                                <img className="close-icon cursor-pointer" onClick={this.props.onClose} src={getImageSource(ImageConstants.CROSS)} />
                            </div>
                        </div>

                        <div className="text-center">
                            <div className="title">{this.props.title || "Are you sure you want to Archive this item?"}</div>
                        </div>

                        <div className="text-center py-4">
                            <button className="cw-button-primary light mr-2" onClick={this.onCLickCancel}>
                                Cancel
                                </button>
                            <button className="cw-button-primary" onClick={this.onClickArchive}>
                                Archive
                            </button>
                        </div>
                    </div>
                </ModalBody>

            </Modal >
        );
    }
}

export default ArchiveComponent;